export default "__VITE_ASSET__D1qz395w__"